import React, { memo, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { useHistory } from "react-router-dom";
// import checkIcon from "../../../src/assets/images/fe_check.jpeg";
import axiosInstance from "../../axios/axios";
import { Decrypt_Value } from "../../MiddleWare/EncryptDecrypt";
import { useDispatch } from "react-redux";
import { GetNav } from "../../StateManagement/Reducers/ScheduleState";
import { SpinnerDiv } from "../../StyledComponents";
import { Spinner } from "react-bootstrap";
import { clearGetStarted } from "../../StateManagement/Reducers/GetStartedState";

const UserGuide = ({ close, goToCalender, ProviderName, welcome }) => {
  // ------------------------------ State and Variables Start----------------------------------------- //

  const history = useHistory();

  const userId =
    localStorage.getItem("user_id") &&
    Decrypt_Value(localStorage.getItem("user_id"), "vozo");
  const [stepClientInfo, setStepClientInfo] = useState(false);
  const [stepUsersBilling, setStepUsersBilling] = useState(false);
  const [stepServiceCodes, setStepServiceCodes] = useState(false);
  const [stepPatientPortal, setStepPatientPortal] = useState(false);
  const [stepTemplates, setStepTemplates] = useState(false);
  const [stepPatientsAppointments, setStepPatientsAppointments] =
    useState(false);
  const [stepPatientReminder, setStepPatientReminder] = useState(false);
  const [stepBillingMembership, setStepBillingMembership] = useState(false);
  const [stepThirdPartyIntegration, setStepThirdPartyIntegration] =
    useState(false);
  const [spinnerVal, setSpinnerVal] = useState(true);

  var owner_id = Decrypt_Value(localStorage.getItem("owner_id"), "vozo");
  const dispatch = useDispatch();

  // ------------------------------ State and Variables End----------------------------------------- //

  // ------------------------------ Functions Start--------------------------------------------------- //

  const forexploreclient = () => {
    dispatch(clearGetStarted());
    close();
    if (welcome) {
      goToCalender();
    }
    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("personalSetupTourReturnTo", "userGuide");

    history.replace({
      pathname: "/settings/settingsmyprofile",
      search: "?step=1.1",
    });
  };

  const forexploreusersandbilling = () => {
    dispatch(clearGetStarted());
    close();
    if (welcome) {
      goToCalender();
    }
    dispatch(GetNav("iconopen"));
    history.push({
      pathname: "/settings/Users",
      state: { showUserPopup: true },
    });
  };

  const forexplorebillservice = () => {
    dispatch(clearGetStarted());
    close();
    if (welcome) {
      goToCalender();
    }
    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("serviceCodeTourReturnTo", "userGuide");

    history.push({
      pathname: `/settings/settingservice`,
      data: { serbillgetstart1: true },
    });
  };

  const forexploretemplates = () => {
    dispatch(clearGetStarted());
    close();
    if (welcome) {
      goToCalender();
    }
    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("templateTourReturnTo", "userGuide");

    history.push({
      pathname: `/settings/Templates`,
      state: { showTemplatePopup: true },
    });
  };
  const forexplorepatientportal = () => {
    dispatch(clearGetStarted());
    close();
    if (welcome) {
      goToCalender();
    }
    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("patientPortalTourReturnTo", "userGuide");

    history.replace({
      pathname: `/settings/patientportal/all`,
      state: { patientportalstarted: true },
    });
  };

  const forexplorefacistaff = () => {
    dispatch(clearGetStarted());
    close();
    if (welcome) {
      goToCalender();
    }
    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("patientAppointmentTourReturnTo", "userGuide");

    history.replace({
      pathname: "/patient/patientlist",
      search: "?step=6.1",
    });
  };

  const forexploreremindersetup = () => {
    dispatch(clearGetStarted());
    close();

    if (welcome) {
      goToCalender();
    }

    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("reminderTourReturnTo", "userGuide");

    history.replace({
      pathname: "/schedule/calender",
      search: "?step=36.1",
      state: {
        fromAccountSetup: true,
        reminderTourReturnTo: "userGuide",
      },
    });
  };

  const forexplorebillingmembership = () => {
    dispatch(clearGetStarted());
    close();

    if (welcome) {
      goToCalender();
    }

    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("membershipTourReturnTo", "userGuide");

    history.replace({
      pathname: "/patient/membershipplan",
      state: {
        membershipplanstarted: true,
        fromAccountSetup: true,
        membershipTourReturnTo: "userGuide",
      },
    });
  };

  const forexplorethirdpartyintegration = () => {
    dispatch(clearGetStarted());
    close();

    if (welcome) {
      goToCalender();
    }

    dispatch(GetNav("iconopen"));

    sessionStorage.setItem("thirdPartyTourReturnTo", "userGuide");

    history.replace({
      pathname: "/settings/integrations",
      state: {
        integrationstarted: true,
        fromAccountSetup: true,
        thirdPartyTourReturnTo: "userGuide",
      },
    });
  };

  const fetchSeenSteps = async () => {
    try {
      const response = await axiosInstance.get(
        `/vozo/get-started?patient_id=${userId}`,
      );
      const decryptedResponse = Decrypt_Value(response.data, "vozo");

      decryptedResponse.map((step) => {
        if (step.intro_key === "stepOne") {
          setStepClientInfo(true);
        } else if (step.intro_key === "stepTwo") {
          setStepUsersBilling(true);
        } else if (step.intro_key === "stepThree") {
          setStepServiceCodes(true);
        } else if (step.intro_key === "stepFour") {
          setStepPatientPortal(true);
        } else if (step.intro_key === "stepFive") {
          setStepTemplates(true);
        } else if (step.intro_key === "stepSix") {
          setStepPatientsAppointments(true);
        } else if (step.intro_key === "stepSeven") {
          setStepPatientReminder(true);
        } else if (step.intro_key === "stepEight") {
          setStepBillingMembership(true);
        } else if (step.intro_key === "stepNine") {
          setStepThirdPartyIntegration(true);
        }
      });
    } catch (err) {
      console.error("Failed to fetch get-started steps", err);
    } finally {
      setSpinnerVal(false);
    }
  };

  // ------------------------------ Functions End -------------------------------- //

  useEffect(() => {
    setTimeout(fetchSeenSteps, 100);
  }, []);

  const renderGuideItem = (isCompleted, title, description, onClick) => (
    <button type="button" className="ug-guide-item" onClick={onClick}>
      <span
        className={
          isCompleted
            ? "ug-guide-status ug-guide-status-completed"
            : "ug-guide-status"
        }
      >
        {isCompleted ? "✓" : ""}
      </span>

      <span className="ug-guide-content">
        <span className="ug-guide-title">{title}</span>
        <span className="ug-guide-desc">{description}</span>
      </span>

      <span className="ug-guide-arrow">›</span>
    </button>
  );

  return (
    <div id="user_guide_page" className="ug-popup-shell">
      <Form onSubmit={(e) => e.preventDefault()}>
        <Modal.Header closeButton>
          <div className="user-gui-title">
            <span>Get Started with a Quick Product Tour!</span>
          </div>
        </Modal.Header>

        <Modal.Body className="ug-popup-body">
          {spinnerVal ? (
            <SpinnerDiv
              style={{
                display: "flex",
                justifyContent: "center",
                padding: "1rem",
              }}
            >
              <Spinner animation="border" variant="primary" />
            </SpinnerDiv>
          ) : (
            // <div className="ug-popup-inner-scroll">
            //   <div className="user-gui-title-small">
            //     We’ll guide you through the essentials for a smooth start. Takes
            //     only a few mins.
            //   </div>

            //   <div className="user-guide-list-1">
            //     <div className="block-display">
            //       <div
            //         className="for-user-guide-list-data-1"
            //         onClick={() => forexploreclient()}
            //       >
            //         Set up your Personal & Facility Info
            //       </div>
            //       <div className="for-user-guide-list-data-2">
            //         Get started by entering your info, setting up your facility.
            //       </div>
            //     </div>

            //     {stepClientInfo && (
            //       <img
            //         src={checkIcon}
            //         alt="check icon"
            //         className="check-icon"
            //       />
            //     )}
            //   </div>

            //   <div className="user-guide-list-2">
            //     <div className="block-display">
            //       <div
            //         className="for-user-guide-list-data-1"
            //         onClick={() => forexploreusersandbilling()}
            //       >
            //         Users & Billing Setup
            //       </div>
            //       <div className="for-user-guide-list-data-2">
            //         Start with adding your team members and setting up your
            //         billing preferences along with your clearing house to start
            //         managing claims.
            //       </div>
            //     </div>
            //     {stepUsersBilling && (
            //       <img
            //         src={checkIcon}
            //         alt="check icon"
            //         className="check-icon"
            //       />
            //     )}
            //   </div>

            //   <div className="user-guide-list-2">
            //     <div className="block-display">
            //       <div
            //         className="for-user-guide-list-data-1"
            //         onClick={() => forexplorebillservice()}
            //       >
            //         Manage your Service Codes
            //       </div>
            //       <div className="for-user-guide-list-data-2">
            //         Manage existing service codes and further add your preferred
            //         service codes in the system.
            //       </div>
            //     </div>
            //     {stepServiceCodes && (
            //       <img
            //         src={checkIcon}
            //         alt="check icon"
            //         className="check-icon"
            //       />
            //     )}
            //   </div>

            //   {(owner_id === null || owner_id === " ") && (
            //     <div className="user-guide-list-2">
            //       <div className="block-display">
            //         <div
            //           className="for-user-guide-list-data-1"
            //           onClick={() => forexplorepatientportal()}
            //         >
            //           Patient Portal Configuration
            //         </div>
            //         <div className="for-user-guide-list-data-2">
            //           Enable and customize your patient portal to provide easy
            //           access for patients.
            //         </div>
            //       </div>
            //       {stepPatientPortal && (
            //         <img
            //           src={checkIcon}
            //           alt="check icon"
            //           className="check-icon"
            //         />
            //       )}
            //     </div>
            //   )}

            //   <div className="user-guide-list-7">
            //     <div className="block-display">
            //       <div
            //         className="for-user-guide-list-data-1"
            //         onClick={() => forexploretemplates()}
            //       >
            //         Create and Customise Templates
            //       </div>
            //       <div className="for-user-guide-list-data-2">
            //         Create, manage, and organize templates to simplify your
            //         workflow
            //       </div>
            //     </div>
            //     {stepTemplates && (
            //       <img
            //         src={checkIcon}
            //         alt="check icon"
            //         className="check-icon"
            //       />
            //     )}
            //   </div>

            //   <div className="user-guide-list-7">
            //     <div className="block-display">
            //       <div
            //         className="for-user-guide-list-data-1"
            //         onClick={() => forexplorefacistaff()}
            //       >
            //         Add Patients and Schedule their appointments
            //       </div>
            //       <div className="for-user-guide-list-data-2">
            //         Add new patients and manage patient records along with their
            //         appointments and its details.
            //       </div>
            //     </div>
            //     {stepPatientsAppointments && (
            //       <img
            //         src={checkIcon}
            //         alt="check icon"
            //         className="check-icon"
            //       />
            //     )}
            //   </div>

            //   <div className="user-guide-list-7">
            //     <div className="block-display">
            //       <div className="user-gui-title-footer">
            //         <span>
            //           For further information regarding other functions refer{" "}
            //           <br /> to our{" "}
            //           <a
            //             href="https://help.vozohealth.com"
            //             target="_blank"
            //             rel="noreferrer"
            //           >
            //             <span>Help Document</span>
            //           </a>{" "}
            //           or our <span>Resource Videos.</span>
            //         </span>
            //       </div>
            //     </div>
            //   </div>
            // </div>
            <div className="ug-popup-inner-scroll">
              <div className="user-gui-title-small">
                We’ll guide you through the essentials for a smooth start. Takes
                only a few mins
              </div>

              <div className="ug-guide-list">
                {renderGuideItem(
                  stepClientInfo,
                  "Set up your Personal & Facility info",
                  "Get started by entering your info, setting up your facility.",
                  forexploreclient,
                )}

                {renderGuideItem(
                  stepUsersBilling,
                  "Users Setup",
                  "Add and manage providers, staff members, and user roles to organize your team and streamline day-to-day operations within the application.",
                  forexploreusersandbilling,
                )}

                {renderGuideItem(
                  stepServiceCodes,
                  "Manage your Service Codes",
                  "Manage existing service codes and further add your preferred service codes in the system.",
                  forexplorebillservice,
                )}

                {(owner_id === null || owner_id === " ") &&
                  renderGuideItem(
                    stepPatientPortal,
                    "Patient Portal Configuration",
                    "Enable and customize your patient portal to provide easy access for patients.",
                    forexplorepatientportal,
                  )}

                {renderGuideItem(
                  stepTemplates,
                  "Create and Customise Templates",
                  "Create, manage, and organize templates to simplify your workflow",
                  forexploretemplates,
                )}

                {renderGuideItem(
                  stepPatientsAppointments,
                  "Add Patients and Schedule their appointments",
                  "Add new patients and manage patient records along with their appointments and its details.",
                  forexplorefacistaff,
                )}

                {renderGuideItem(
                  stepPatientReminder,
                  "Patient Reminder Setup",
                  "Configure automated patient reminders to notify patients about upcoming appointments and follow-ups",
                  forexploreremindersetup,
                )}

                {renderGuideItem(
                  stepBillingMembership,
                  "Create Billing Membership Plan",
                  "Set up customized billing membership plans with recurring payments and coverage details",
                  forexplorebillingmembership,
                )}

                {renderGuideItem(
                  stepThirdPartyIntegration,
                  "Set up 3rd Party Integration",
                  "Connect and manage third-party integrations to streamline workflows, synchronize data, and enhance practice operations.",
                  forexplorethirdpartyintegration,
                )}
              </div>

              <div className="ug-guide-footer">
                <div>
                  For further information regarding other functions refer to our{" "}
                  <a
                    href="https://help.vozohealth.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Help Document
                  </a>{" "}
                  or our{" "}
                  <span className="ug-guide-link-text">Resource Videos.</span>
                </div>

                <div className="ug-guide-footer-note">
                  You can also configure and explore the overall application
                  from the{" "}
                  <span
                    className="ug-guide-link-text"
                    onClick={forexploreclient}
                  >
                    Account Setup
                  </span>{" "}
                  page by navigating through the product using the guided
                  product tour.
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
      </Form>
    </div>
  );
};

export default memo(UserGuide);
